export default {
  validateType(val){
    console.log("Pre ",val)
    if(!val) return false
    val = val.replace("/\\000026/g","")
    console.log("Post ",val)
    if(!(/\\\/\/\\=/.test(val))) return false // barcode from a scanner would be of the format \//\=.+
    console.log("Valid Signature")
    let s = val.replace(/\\\/\/\\=/,'').split('-')[0]
    let types = ["VSID","J"]
    if(types.filter(x=>x===s)[0]){
      console.log(types.filter(x=>x===s)[0])
      return types.filter(x=>x===s)[0]
    }
    return false
  }
};
